import type { ILoggedUser } from "@/entities/auth/types.ts"
import { useAuthStore } from "@/features/auth/model/store.ts"
import { AUDITOR_BASE_ROLES_VALUES, BASE_ROLES, COMPANY_BASE_ROLES_VALUES } from "@/shared/constants"

interface IUseCurrentUserReturn extends Partial<ILoggedUser> {
  isAuditor: boolean
  isRegionAdmin: boolean
  isCompany: boolean
  isSuperAdmin: boolean
  isRepublicAdmin: boolean
}

export const useCurrentUser = (): IUseCurrentUserReturn => {
  const { me } = useAuthStore()

  if (!me) {
    return {
      isAuditor: false,
      isRegionAdmin: false,
      isCompany: false,
      isSuperAdmin: false,
      isRepublicAdmin: false
    }
  }

  const isSuperAdmin = me.base_role === BASE_ROLES.REPUBLIC_INSPECTOR || me.base_role === BASE_ROLES.SUPER_ADMIN
  const isRepublicAdmin = me.base_role === BASE_ROLES.REPUBLIC_INSPECTOR
  const isRegionAdmin = me.base_role === BASE_ROLES.REGIONAL_INSPECTOR
  const isAuditor = AUDITOR_BASE_ROLES_VALUES.includes(me.base_role)
  const isCompany = COMPANY_BASE_ROLES_VALUES.includes(me.base_role)

  return { ...me, isAuditor, isRegionAdmin, isCompany, isRepublicAdmin, isSuperAdmin }
}
